import React from 'react';
import { Typography } from '@mui/material';

interface PatientInfoItemProps {
  label: string;
  value: React.ReactNode;
  variant?: 'body1' | 'body2' | 'caption';
}

/**
 * Reusable component for patient information items
 * Displays a label in primary color with bold weight, followed by the value in secondary color
 */
export const PatientInfoItem: React.FC<PatientInfoItemProps> = ({
  label,
  value,
  variant = 'body2',
}) => (
  <Typography variant={variant} color="text.secondary" component="div">
    <Typography component="span" variant={variant} color="text.primary" sx={{ fontWeight: 600 }}>
      {label}:
    </Typography>{' '}
    {value}
  </Typography>
);